import { Box } from '@mui/material';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AchievementsPage from '../components/pages/AchievementsPage/AchievementsPage';
import EducationPage from '../components/pages/EducationPage/EducationPage';
import MouPage from '../components/pages/MouPage/MouPage';
import PressReleasePage from '../components/pages/PressReleasePage';
import VideoPage from '../components/pages/VideoPage';

const Footprints = () => {
  return <Box>Footprints</Box>;
};

export default function FootprintsRouter() {
  return (
    <Routes>
      <Route path='/' element={<Footprints />} />
      <Route path='/achievement' element={<AchievementsPage />} />
      <Route path='/edu' element={<EducationPage />} />
      <Route path='/video' element={<VideoPage />} />
      <Route path='/mou' element={<MouPage />} />
      <Route path='/release' element={<PressReleasePage />} />
    </Routes>
  );
}
